
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39 33.21H25.3L4.76 11.66s7.86-8.73 9.31-9.33 3.49-.3 3.79 1.5-.3 3.61 2.32 6.92 8.15 3.32 8.15 3.32l5 11.92s5.67.12 5.67 7.22z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M39 33.63v4.32H22.75L1.34 15.2l2.97-3.06M7.41 28.35H0M12.45 33.56H0M9.57 17.76a7.8 7.8 0 00.62-12.46M33.28 25.99h-5.71L21.2 11.91"}})])
          )
        }
      }
    